import styled from 'styled-components'
import { Flex } from './Flex'

const Window = styled(Flex)`
flex-direction:column;
background:white;
border:1px solid grey;
border-radius:10px;
padding:20px;
`

export default Window
